import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faSearch, faTimesCircle, faCloudUploadAlt, faDownload } from '@fortawesome/free-solid-svg-icons';
import { useMainContext } from "../../../../contexts/MainContext";

//ACTIONS AND CONTEXT
import ModalAddTemplates from '../../../../components/atoms/ModalAddTemplates';
import Dropdown from "../../../../components/atoms/Dropdown";
var _ = require('lodash');

/**
    * Componente SearchTemplatesFilters
    * @component
    * @param  props
    * 
*/
const SearchTemplatesFilters = ({ }) => {
    const [showModal, setShowModal] = useState(false);
    let mainContext = useMainContext();

    const closeModal = () => {
        setShowModal(false)
        mainContext.setIsLoading(false);
    }
    return (
        <>
            <ModalAddTemplates showModal={showModal} setShow={closeModal} />
            <div className="content-filters">
                <div className="content-filters-left">
                    <div id="contentSearchBar">
                        <label><b>Nombre de Plantilla</b></label>
                        <div id="search">
                            <button type="submit" id="searchButton">
                                <span className="iconSearch">
                                    <FontAwesomeIcon icon={faSearch} />
                                </span>
                            </button>
                            <input type="text" id="inputSearch" placeholder="Nombre" />
                        </div>
                    </div>
                    <div className="select-filter">
                        <label><b>Giro</b></label>
                        <Dropdown optionLabel="gyreName" optionValue="gyreID" />
                    </div>
                    <div className="w-100px pt-3">
                        <span className="btn-icon mt-3 mr-3"><FontAwesomeIcon size="2x" icon={faSearch} /></span>
                        <span className="btn-icon mt-3"><FontAwesomeIcon size="2x" icon={faTimesCircle} /></span>
                    </div>
                </div>
                <div className="content-filters-right">
                    <button className="buttonAdd btn-icon tooltip" onClick={() => { setShowModal(true) }}>
                        <span className="mt-3"><FontAwesomeIcon size="2x" icon={faPlusCircle} /></span>
                        <span className="tooltiptext">Agregar Plantilla</span>
                    </button>
                    <button className="buttonAdd btn-icon tooltip">
                        <span className="mt-3"><FontAwesomeIcon size="2x" icon={faCloudUploadAlt} /></span>
                        {/* <span className="tooltiptext">Agregar Importación</span> */}
                    </button>
                </div>
            </div>
        </>
    )
}
export default SearchTemplatesFilters;